import Component from "@glimmer/component"
import type { CardStack, CardStackSummary } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"

interface Signature {
  Args: {
    models: {
      courseDate: CourseDateCombined
      course: Course
      lesson: CardStack
      units: Array<CardStackSummary>
      rotationCalendar: RotationCalendar
      planbook: Planbook
      dateString: string
    }
    editCourseTitleAndOrder: Function
    lessonsCollapsed: boolean
    perspective: "day" | "week" | "month"
    isFullScreen?: boolean
    sortableParent?: unknown
  }
}

export default class LessonEditableComponent extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::LessonEditable": typeof LessonEditableComponent
  }
}
